import React, { useContext, useEffect, useState } from 'react';
import { ColorContext } from 'App';
import { useNavigate } from 'react-router-dom';

import { Container, Button } from 'react-bootstrap';
import { CustomInput } from 'components/UI/CustomInput';

import background from 'assets/Resc_Office.png';
import logo from '../components/Nav/assets/Sidebar_Logo_Open.png';
import logoDEV from '../components/Nav/assets/Sidebar_Logo_Open_DEV.png';
import logoSTAGING from '../components/Nav/assets/Sidebar_Logo_Open_STAGING.png';
import openLogoPITTSBURGHPA from '../components/Nav/assets/Sidebar_Logo_Open_PittsburghPA.png';
import openLogoCOMALTX from '../components/Nav/assets/Sidebar_Logo_Open_ComalTX.png';
import openLogoHARRISONKY from '../components/Nav/assets/Sidebar_Logo_Open_HarrisonKY.png';
import { _Environment } from 'services/_infra/environment';
import { sendResetEmail } from 'services/account/account.service';
import { getLogo } from 'utils/imageUtils';

export const ForgotPassword = ({ setShowSmallMenu, mobile = false }) => {
  const theme = useContext(ColorContext);
  const navigate = useNavigate();
  const [resetEmail, setResetEmail] = useState('');
  const [resetMessage, setResetMessage] = useState('');

  const onPasswordReset = async () => {
    if (!resetEmail) {
      return;
    }
    try {
      const res = await sendResetEmail(resetEmail);

      setResetMessage('Password reset email sent.');
      setTimeout(() => {
        navigate('/');
      }, 2500);
    } catch (e) {
      setResetMessage('Error sending reset email.');
    }
  };

  useEffect(() => {
    setShowSmallMenu(false);
  }, []);

  return (
    <div>
      <Container
        fluid
        className="vh-100 overflow-y-auto"
        style={{ margin: 0, padding: 0, position: 'fixed', inset: 0 }}
      >
        <div className="flex-box row g-0 h-100 position-relative z-4999">
          <div
            className="col-12 col-md-6 d-none d-md-block flex-grow-1 p-0"
            style={{
              backgroundImage: `url(${background})`,
              backgroundSize: 'cover',
              backgroundPosition: '60% 100%',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <div className="row g-0 h-100 align-items-end text-center">
              <div
                className="mb-5"
                style={{
                  WebkitTextStroke: '0.3px black',
                  color: theme.fontColor,
                }}
              >
                <div style={{ fontSize: 20 }}>Overwatch Fusion </div>
                <div style={{ fontSize: 36 }}>Powered by RescAlert Inc.</div>
              </div>
            </div>
          </div>

          <div
            className="col-12 col-md-6 d-flex flex-column align-items-center justify-content-around p-0"
            style={{ background: theme.background, color: theme.fontColor }}
          >
            {/* Logo */}
            <img
              className="p-3"
              src={getLogo(true)}
              style={{ width: '80%', maxWidth: 500, marginTop: '5%' }}
              alt="Logo"
            />

            {/* Form */}
            <div className="w-100 p-3" style={{ maxWidth: 380 }}>
              <div className="mb-5">
                <h1 className="mb-2">Reset Password</h1>
                <div style={{ color: '#A0AEC0' }}>Enter your email to request password reset</div>
              </div>
              <div className="mb-3">
                <div className="py-1 mx-2">Email</div>

                <CustomInput
                  value={resetEmail}
                  callback={setResetEmail}
                  type="text"
                  placeholder="Your email address"
                />
              </div>

              <Button
                variant="primary"
                className="w-100 rounded-4 mt-5 mb-3 py-3"
                onClick={() => onPasswordReset()}
                disabled={!resetEmail}
              >
                Request Password Reset
              </Button>

              {resetMessage && <div className="mt-2">{resetMessage}</div>}

              <div className="text-center mt-3">
                <span style={{ color: '#A0AEC0' }}>Already have an account? </span>
                <a
                  href={mobile ? '/mobile' : '/'}
                  style={{
                    color: theme.fontColor,
                    textDecoration: 'none',
                    cursor: 'pointer',
                  }}
                >
                  Sign in
                </a>
              </div>
            </div>
            {/* <div className="text-center mt-4">
              <div className="mb-2 fs-5">Sign in with</div>

              <div className="d-flex w-100 flex-nowrap gap-3">
                <Button
                  variant="light"
                  className="flex-fill d-inline-flex align-items-center gap-2 rounded-4 shadow-sm px-5 py-3 text-dark"
                  onClick={() => navigate("/")}
                  aria-label="Sign in with Microsoft"
                >
                  <img src={msLogo} alt="Microsoft" width={28} height={28} />
                  <span className="fw-medium text-nowrap">Microsoft</span>
                </Button>
              </div>
            </div> */}
            <footer className="w-100 py-3 text-center">
              <div className="mb-2">
                <span style={{ color: '#A0AEC0' }}>Don’t have an account? </span>
                <a
                  href="/contact"
                  style={{
                    color: theme.fontColor,
                    textDecoration: 'none',
                    cursor: 'pointer',
                  }}
                >
                  Contact Us
                </a>
              </div>
              <small
                style={{
                  color: theme.fontColor,
                  textShadow: '0 1px 2px rgba(0,0,0,.4)',
                }}
              >
                © 2023–{new Date().getFullYear()}, Powered by RescAlert Inc.
              </small>
              <div className="d-flex justify-content-center flex-wrap gap-4">
                <button
                  type="button"
                  className="btn btn-link text-decoration-none px-0"
                  style={{ color: theme.fontColor, opacity: 0.6 }}
                  onClick={() => {}}
                >
                  Marketplace
                </button>

                <button
                  type="button"
                  className="btn btn-link text-decoration-none px-0"
                  style={{ color: theme.fontColor, opacity: 0.6 }}
                  onClick={() => {}}
                >
                  Blog
                </button>

                <button
                  type="button"
                  className="btn btn-link text-decoration-none px-0"
                  style={{ color: theme.fontColor, opacity: 0.6 }}
                  onClick={() => {}}
                >
                  License
                </button>
              </div>
            </footer>
          </div>
        </div>
      </Container>
    </div>
  );
};
